import {IOrganization, IImomoResponse, ISeasonalFrequencySettings, IStation} from '../../api/api.types';
import {IUser, IForecastType} from '../../api/api.types';
import {IUserApi} from '../../api/user-api.service';
import IOrganizationApi from '../../api/organization-api.service';
import {StateService} from 'angular-ui-router';
import {StateParams} from 'angular-ui-router';
import OrganizationService from './organization.service';
import {IImomoErrorService} from '../../error/error.service';
import {IStationApi} from '../../api/station-api.service';
import {IFilterFilter} from 'angular';
import * as moment from 'moment-timezone';

export interface IOrganizationDetailsStateParams extends StateParams {
    id: string;
}

export namespace IOrganizationEvents {
  export const ORGANIZATION_CHANGE = 'imomo-organization-change';
}

export default class OrganizationController {
  static $inject = ['organizationApi', '$window', '$filter', 'userApi', '$stateParams', 
  '$state', '$mdDialog', 'organizationService', '$rootScope', '$q', 'imomoErrorService', '$scope', 'stationApi', '$translate'];

  private id: number;
  private isInsideOrgSetupWizard: boolean;
  private currentOrganization: IOrganization;
  private organizationData: IOrganization;
  private userData: IUser;
  private users: IUser[];
  private isSaving: boolean = false;
  private isDeleting: boolean = false;
  private isLoading: boolean = true;
  
  private isNew: boolean = false;
  public isEditable: boolean = false;
  private organizations:IOrganization[];
  private forecastTypes: {
    fiveDay: IForecastType,
    decadal: IForecastType,
    monthly: IForecastType
  };
  
  private seasonalForecastTypes: IForecastType[];
  
  
  private organizationForm: ng.IFormController;
  private timezones: string[];
  private timezoneSearchText: string;
  private filter: IFilterFilter;
  private timezone: string;
  private currentUser: IUser;
  private yearTypes: string[]

  constructor(
    private organizationApi: IOrganizationApi,
    private $window: ng.IWindowService,
    private $filter: ng.IFilterService,
    private userApi: IUserApi,
    private $stateParams: IOrganizationDetailsStateParams,
    private $state: StateService,
    private $mdDialog: ng.material.IDialogService,
    private organizationService: OrganizationService,
    private $rootScope: ng.IRootScopeService,
    private $q:ng.IQService,
    private imomoErrorService: IImomoErrorService,
    private $scope: ng.IScope,
    private stationApi:IStationApi,
    private $translate:ng.translate.ITranslateService
  ) {

    const currentTime = new Date();
    const currentOrgId = parseInt(this.$window.localStorage.getItem('currentOrgId'), 10);
    
    this.forecastTypes = {
      fiveDay: {
        name: "5-day",
        sourceId: currentOrgId,
        frequency: "pentadal",
        issueDateOffset: undefined
      },
      decadal: {
        name: "Decadal",
        sourceId: currentOrgId,
        frequency: "decade",
        issueDateOffset: undefined
      },
      monthly: {
        name: "Monthly",
        sourceId: currentOrgId,
        frequency: "monthly",
        issueDateOffset: undefined
      }
    }

    this.yearTypes = ["hydro_year","calendar_year"]

    this.seasonalForecastTypes = [];
    
    if (this.$stateParams.id !== 'new') {
      this.fetchOrganization(this.$stateParams.id || this.id.toString());
    } else {
      this.isNew = true;
      this.isEditable = true;
      this.isLoading = false;
    }

    if (typeof this.isEditable === 'undefined') {
    	this.isEditable = false;
    }

    userApi.getUserList()
      .then(data => {

        data.forEach((user) => {
          delete user.sourceId;
          delete user.registeredOn;
        })

        this.users = data;
      })

    userApi.getCurrentUser()
      .then(data => {
        this.currentUser = data;
      });

    organizationApi.getOrganizations() 
      .then(organizations => {
        this.organizations = organizations;
      });

    if (this.isInsideOrgSetupWizard) {
      this.isEditable = true;
    }

    this.filter = $filter('filter');
    this.timezones = moment.tz.names();
  }

  getMatchedTimezones(searchText: string) {
      return this.filter(this.timezones, searchText).filter(timezone => {
        return this.timezones.indexOf(timezone) != -1;
      });
  }

  private fetchOrganization(id: string) {
    this.organizationApi.getOrganization(parseInt(id, 10))
      .then(data => {
        this.organizationData = data;
        this.$window.localStorage.setItem('currentOrgId', id);
        this.$rootScope.$broadcast(IOrganizationEvents.ORGANIZATION_CHANGE);
        this.organizationApi.getForecastTypes(parseInt(id, 10))
          .then((forecastTypes) => {
             forecastTypes.forEach((forecastType) => {
               switch (forecastType.frequency) {
                 case 'pentadal':
                   this.forecastTypes.fiveDay = forecastType;
                   break;
                 case 'decade':
                   this.forecastTypes.decadal = forecastType;
                   break;
                 case 'monthly':
                   this.forecastTypes.monthly = forecastType;
                   break;
                 case 'seasonal':
                   // console.log(1, forecastType.issueDate,new Date(forecastType.issueDate))
                   // forecastType.issueDate = new Date(forecastType.issueDate);
                   // forecastType.targetPeriodStart = new Date(forecastType.targetPeriodStart);
                   // forecastType.targetPeriodEnd = new Date(forecastType.targetPeriodEnd);
                   this.seasonalForecastTypes.push(forecastType);
                   break;
                 default:
                   break;
               }
             });
          });
        this.isLoading = false;
      }, errorData => {
        this.isLoading = false;
      });
  }

  onOrganizationChange(newOrganizationId:string) {
    
    this.$window.localStorage.setItem('currentOrgId', newOrganizationId);
    this.$rootScope.$broadcast(IOrganizationEvents.ORGANIZATION_CHANGE);
    this.$state.go('organization', {id: newOrganizationId});
  }

  private onCancelClick($event: MouseEvent) {
      this.isEditable = false;
      
      if (this.isNew) {
        this.$state.go('organization', {id: Number.parseInt(this.$window.localStorage.getItem('currentOrgId'))});
      }
  }

  private onSaveClick($event: MouseEvent) {
      let self = this;

      self.isEditable = false;
      self.isSaving = true;

      self.organizationApi.saveOrganization(this.organizationData)
          .then(function (data) {
              self.isSaving = false;
              self.$window.localStorage.setItem('currentOrgId', data.id + '');
              self.$state.go('organization', {id: data.id});
              self.$rootScope.$broadcast(IOrganizationEvents.ORGANIZATION_CHANGE);

              self.submitForecastTypes();
              self.$window.localStorage.setItem('orgTimezone', self.organizationData.timezone);

          }, function (errorData) {
              self.isSaving = false;

              self.$mdDialog.show(
                  self.$mdDialog.alert()
                      .clickOutsideToClose(true)
                      .title(this.$translate.instant('SAVE_FAILED'))
                      .textContent(errorData.data.details)
                      .ok('OK')
                      .targetEvent($event)
              );
          });
  }

  private submitForecastTypes() {
    let forecastTypes: IForecastType[] = [];
    let forecastTypePromises: any = [];
    let currentOrgId = Number.parseInt(this.$window.localStorage.getItem('currentOrgId'));

    if (typeof this.forecastTypes.fiveDay.issueDateOffset !== 'undefined') {
      forecastTypes.push(this.forecastTypes.fiveDay)
    }

    if (typeof this.forecastTypes.decadal.issueDateOffset !== 'undefined') {
      forecastTypes.push(this.forecastTypes.decadal)
    }

    if (typeof this.forecastTypes.monthly.issueDateOffset !== 'undefined') {
      forecastTypes.push(this.forecastTypes.monthly)
    }
    
    forecastTypes.concat(this.seasonalForecastTypes)
      .forEach((forecastType: IForecastType) => {
        if(!forecastType.id) {
          forecastTypePromises
            .push(this.organizationApi.createForecastType(currentOrgId, forecastType));
        } else {
          forecastTypePromises
            .push(this.organizationApi.updateForecastType(currentOrgId, forecastType));
        }
      });

     this.$q.all(forecastTypePromises)
       .then(() => {})
       .catch((error) => {
         this.imomoErrorService.showErrorDetailsDialog(error.data.details);
       })
  }

  private goToCurrentOrg() {
      this.organizationService.getCurrentOrgId()
        .then(id => {
          this.$state.go('organization', {id: id});
        });
    }

  private onBackClick($event: MouseEvent) {
      this.goToCurrentOrg();
  }

  private onDeleteClick($event: MouseEvent) {
      let self = this;

      let confirm = this.$mdDialog.confirm()
          .title(this.$translate.instant('DELETE_ORGANIZATION'))
          .textContent(this.$translate.instant('DELETE_CONFIRMATION', {item: self.organizationData.organization}))
          .targetEvent($event)
          .ok(this.$translate.instant('DELETE'))
          .cancel(this.$translate.instant('CANCEL'));

      this.$mdDialog.show(confirm).then(function() {

          self.isDeleting = true;

          self.organizationApi.deleteOrganization(parseInt(self.$stateParams.id))
              .then(function (data) {
                  self.isDeleting = false;
                  self.$window.localStorage.removeItem('currentOrgId');
                  self.goToCurrentOrg();
                  self.$rootScope.$broadcast(IOrganizationEvents.ORGANIZATION_CHANGE);
              }, function (errorData) {
                  self.isDeleting = false;
              });
      });

    }

    private onSeasonalFrequencyChange(seasonalFrequencies: IForecastType[]) {
      this.seasonalForecastTypes = seasonalFrequencies;
    }
}



/** WEBPACK FOOTER **
 ** ./app/hydromet/organization/organization.controller.ts
 **/